import * as React from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";

import { MetaTags } from "../../../head";
import { RootState, Dispatch } from "../../../store/types";
import { ProductStyle } from "../../../models";
import { LoadingSpinner, Wrapper } from "../../../components";
import StepLayout from "../../Wizard/components/WizardStepLayout";
import { StyleChoiceState } from "../reducer";
import * as actions from "../actions";
import * as selectors from "../selectors";
import StyleItem from "./StyleItem";
import StyleList from "./StyleList";
import { State as Step1State, selectors as step1Selectors } from "../../Step1";
import { ATT_MATRIX_VALS } from "../../Wizard/constants";

export interface StyleChoiceProps extends StyleChoiceState, Step1State {
  fetchStyles: () => void;
  updateDescVal: (e: React.SyntheticEvent<HTMLInputElement>) => void;
  setStyleSelection: (s?: ProductStyle) => void;
}

class StyleChoiceContainer extends React.Component<StyleChoiceProps> {
  public componentDidMount() {
    this.props.fetchStyles();
  }

  public render() {
    if (!this.props.chosenProduct) {
      // Go to step 1 if no product chosen
      return <Redirect to="/wizard/step-1" />;
    } else if (
      this.props.chosenProduct.attribute.style === ATT_MATRIX_VALS.NA
    ) {
      // Skip this step if not applicable
      return <Redirect to="/wizard/step-4" />;
    }

    return (
      <Wrapper>
        <MetaTags title="Danh sách phong cách" />
        <StepLayout
          title="Phong cách và tông màu nào sẽ phù hợp với thiết kế của bạn?"
          banner="Chúng tôi sẽ tham khảo mong muốn của bạn và tư vấn tốt nhất cho màu sắc của sản phẩm"
        >
          <StyleList>{this.renderStyleItems()}</StyleList>
        </StepLayout>
      </Wrapper>
    );
  }

  private renderStyleItems() {
    if (this.props.isStylesLoading) {
      return <LoadingSpinner large />;
    }

    return this.props.styles.map(style => (
      <StyleItem {...style} key={style.id} onClick={this.selectStyle(style)} />
    ));
  }

  private selectStyle = (style: ProductStyle) => () => {
    let arg;

    if (
      this.props.selectedStyle == null ||
      this.props.selectedStyle.id !== style.id
    ) {
      arg = style;
    }

    this.props.setStyleSelection(arg);
  };
}

const mapStateToProps = (state: RootState): Partial<StyleChoiceProps> => ({
  descriptionValue: selectors.descriptionValue(state),
  styles: selectors.displayStyles(state),
  isStylesLoading: selectors.isStylesLoading(state),
  selectedStyle: selectors.selectedStyle(state),
  chosenProduct: step1Selectors.chosenProduct(state),
});

const mapDispatchToProps = (dispatch: Dispatch): Partial<StyleChoiceProps> => ({
  fetchStyles: () => dispatch(actions.fetchStyles()),
  setStyleSelection: (style?: ProductStyle) =>
    dispatch(actions.setStyleSelection(style)),
  updateDescVal: (event: React.SyntheticEvent<HTMLInputElement>) => {
    const input: HTMLInputElement = event.target as HTMLInputElement;
    dispatch(actions.setDescVal(input.value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(
  StyleChoiceContainer,
);



// WEBPACK FOOTER //
// ./src/routes/WizardStyleChoice/components/StyleChoiceContainer.tsx